import template from './rw-copyright.html';

export default {
  template,
  controller: 'RwCopyrightController',
};



// WEBPACK FOOTER //
// ./src/modules/utils/rw-copyright/rw-copyright-component.js